module.exports = __webpack_public_path__ + "static/media/akvakultura.8eb0727b.pdf";